"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;

var _react = _interopRequireWildcard(require("react"));

var _reactSound = _interopRequireDefault(require("react-sound"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonModule = _interopRequireDefault(require("./Button.module.scss"));

var _EButtonType = _interopRequireDefault(require("./EButtonType"));

var _assets = require("../../../assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HOVER_SOUND = "".concat(_assets.ASSETS_INTERFACE_SOUNDS, "/button_over.wav");
var CLICK_SOUND = "".concat(_assets.ASSETS_INTERFACE_SOUNDS, "/001001_Klick_Version_01.mp3");
var CLICK_SOUND_DURATION_MS = 200;

function getRandomSoundKey() {
  return Math.random().toString(36).substr(2, 9);
}

function Button(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _EButtonType.default.BUTTON : _ref$type,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isHoverSoundEnab = _ref.isHoverSoundEnabled,
      isHoverSoundEnabled = _ref$isHoverSoundEnab === void 0 ? false : _ref$isHoverSoundEnab,
      _ref$isClickSoundEnab = _ref.isClickSoundEnabled,
      isClickSoundEnabled = _ref$isClickSoundEnab === void 0 ? false : _ref$isClickSoundEnab,
      _ref$soundVolume = _ref.soundVolume,
      soundVolume = _ref$soundVolume === void 0 ? 100 : _ref$soundVolume,
      onClick = _ref.onClick,
      onDoubleClick = _ref.onDoubleClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$contentClassName = _ref.contentClassName,
      contentClassName = _ref$contentClassName === void 0 ? "" : _ref$contentClassName,
      style = _ref.style;

  var _useState = (0, _react.useState)(HOVER_SOUND),
      _useState2 = _slicedToArray(_useState, 2),
      soundSrc = _useState2[0],
      setSoundSrc = _useState2[1];

  var _useState3 = (0, _react.useState)(getRandomSoundKey()),
      _useState4 = _slicedToArray(_useState3, 2),
      soundKey = _useState4[0],
      setSoundKey = _useState4[1];

  var _useState5 = (0, _react.useState)("STOPPED"),
      _useState6 = _slicedToArray(_useState5, 2),
      soundStatus = _useState6[0],
      setSoundStatus = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = _slicedToArray(_useState7, 2),
      soundPos = _useState8[0],
      setSoundPos = _useState8[1];

  var handleOnDoubleClick = (0, _react.useCallback)(function () {
    if (onDoubleClick) onDoubleClick();
  }, [onDoubleClick]);
  var handleOnClick = (0, _react.useCallback)(function () {
    if (isClickSoundEnabled && !isDisabled) {
      setSoundStatus("STOPPED");
      setSoundPos(0);
      setSoundKey(getRandomSoundKey());
      setSoundSrc(CLICK_SOUND);
      setSoundStatus("PLAYING");
    } // used to play sound even when handler removes the button


    setTimeout(function () {
      if (onClick) onClick();
    }, isClickSoundEnabled ? CLICK_SOUND_DURATION_MS : 0);
  }, [isClickSoundEnabled, isDisabled, onClick]);
  var handleOnMouseEnter = (0, _react.useCallback)(function () {
    if (isHoverSoundEnabled && !isDisabled) {
      setSoundStatus("STOPPED");
      setSoundPos(0);
      setSoundKey(getRandomSoundKey());
      setSoundSrc(HOVER_SOUND);
      setSoundStatus("PLAYING");
    }
  }, [isHoverSoundEnabled, isDisabled]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, soundStatus === "PLAYING" && /*#__PURE__*/_react.default.createElement(_reactSound.default, {
    key: soundKey,
    url: soundSrc,
    position: soundPos,
    volume: soundVolume,
    playStatus: soundStatus,
    onFinishedPlaying: function onFinishedPlaying() {
      return setSoundStatus("STOPPED");
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    disabled: isDisabled,
    onClick: handleOnClick,
    onDoubleClick: handleOnDoubleClick,
    onMouseEnter: handleOnMouseEnter,
    className: (0, _classnames.default)(_ButtonModule.default.button, _ButtonModule.default[type], className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ButtonModule.default.content, contentClassName)
  }, children)));
}